import React from 'react';
import { Asset } from '../../../types/asset';
import styled from 'styled-components';
import { Block } from '../../other/block';

const TechPartnerContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

const PartnerTitle = styled.span`
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-decoration-color: #46FF46;
`;

interface Partner {
    title: string;
    logo: Asset;
    summary: string;
    category?: string;
}

interface PartnerProps {
    name: string;
    partners: Partner[];
}

export const TechPartnerCollection: React.FC<PartnerProps> = ({ name, partners }) => {
    return (
        <div className="w-full">
            <TechPartnerContainer className="w-full">
                {partners.map((partner, index) => (
                    <div key={index} className={`${ (index + 1) % 3 !== 0 ? 'border-r' : ''} border-stone border-b`}>
                        <div className="px-16 py-10 xl:py-20 xl:px-32">
                            <div className="">
                                <img className="h-12" src={partner.logo.url} alt={partner.logo.name} />
                            </div>
                            <div className="relative w-auto mt-10 font-semibold">
                                <PartnerTitle>
                                    {partner.title}
                                </PartnerTitle>
                            </div>
                            {partner.category &&
                                (
                                    <div className="text-base">
                                        {partner.category}
                                    </div>
                                )
                            }
                            <div className="mt-8 text-base">
                                <div className="" dangerouslySetInnerHTML={{__html: partner.summary}} />
                            </div>
                        </div>
                    </div>
                ))}
            </TechPartnerContainer>
        </div>
    );
};
